import React from "react";
import createBaseRenderer from "./createBaseRenderer";

export default createBaseRenderer({
  name: "doplnkoveSluzby",
  content: ({ val }) => (
    <div>
      {val.map(item => (
        <div key={item.id}>{item.zkratka}</div>
      ))}
    </div>
  )
});
